import { render } from "./elem-select.vue?vue&type=template&id=0ee4bbd2&ts=true"
import script from "./elem-select.vue?vue&type=script&lang=ts"
export * from "./elem-select.vue?vue&type=script&lang=ts"

import "./elem-select.vue?vue&type=style&index=0&id=0ee4bbd2&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__